import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LayoutService } from '../../services/layout/app.layout.service';

@Component({
    standalone: true,
    selector: 'ngx-no-column-layout',
    template: `
        <div class="layout-wrapper layout-no-column" [ngClass]="containerClass">
            <div class="layout-main-container">
                <div class="layout-main">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, RouterModule]
})
export class NoColumnLayoutComponent {
    constructor(public layoutService: LayoutService) {}

    get containerClass() {
        return {
            'layout-theme-light': this.layoutService.config().colorScheme === 'light',
            'layout-theme-dark': this.layoutService.config().colorScheme === 'dark',
            //'layout-overlay': this.layoutService.config().menuMode === 'overlay',
            //'layout-static': this.layoutService.config().menuMode === 'static',
            //'layout-static-inactive': this.layoutService.state.staticMenuDesktopInactive && this.layoutService.config().menuMode === 'static',
            //'layout-overlay-active': this.layoutService.state.overlayMenuActive,
            'layout-mobile-active': this.layoutService.state().staticMenuMobileActive,
            'p-input-filled': this.layoutService.config().inputStyle === 'filled',
            'p-ripple-disabled': !this.layoutService.config().ripple
        };
    }
}
